import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoaderService } from 'src/app/components/loader/service/loader.service';
import { QuizService } from '../services/quiz.service';
import { QuizItem } from '../interfaces/quiz.interface';

@Component({
  selector: 'app-quiz-respond',
  templateUrl: './quiz-respond.component.html',
  styleUrls: ['./quiz-respond.component.css'],
})
export class QuizRespondComponent implements OnInit {
  quiz: QuizItem | null = null;
  respondForm: FormGroup;
  isEditMode = false;
  answerId: string | number | null = null;
  showLoader = false;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private loaderService: LoaderService,
    private quizService: QuizService
  ) {
    this.respondForm = this.fb.group({
      answer_1: [''],
      answer_2: [''],
      answer_3: [''],
      answer_4: [''],
      answer_5: [''],
    });
  }

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.loadQuiz(id);
    }
  }

  loadQuiz(id: string | number): void {
    this.showLoader = true;
    this.quizService
      .getQuizById(id)
      .then((res) => {
        this.quiz = res.data || res;
        this.showLoader = false;

        // Se estiver expirado, não deve poder responder, redireciona de volta.
        if (this.quiz && new Date(this.quiz.end_date) < new Date()) {
          this.snackBar.open('Este quiz já foi encerrado e não aceita mais respostas.', null, { duration: 4000 });
          this.router.navigate(['/devocional/view', id]);
          return;
        }

        if (this.quiz?.user_answer) {
          this.isEditMode = true;
          this.answerId = this.quiz.user_answer.id;
          this.respondForm.patchValue({
            answer_1: this.quiz.user_answer.answer_1,
            answer_2: this.quiz.user_answer.answer_2,
            answer_3: this.quiz.user_answer.answer_3,
            answer_4: this.quiz.user_answer.answer_4,
            answer_5: this.quiz.user_answer.answer_5,
          });
        }
      })
      .catch((err) => {
        this.snackBar.open('Erro ao carregar os dados do quiz.', null, { duration: 3000 });
        this.showLoader = false;
        this.router.navigate(['/devocional']);
      });
  }

  hasAtLeastOneAnswer(): boolean {
    const values = this.respondForm.value;
    return !!(values.answer_1 || values.answer_2 || values.answer_3 || values.answer_4 || values.answer_5);
  }

  onSubmit(): void {
    if (!this.hasAtLeastOneAnswer()) {
      this.snackBar.open('Preencha pelo menos uma resposta para poder salvar.', null, { duration: 3000 });
      return;
    }

    if (!this.quiz?.id) return;

    this.loaderService.showLoader();
    const formData = this.respondForm.value;

    const request =
      this.isEditMode && this.answerId
        ? this.quizService.updateAnswer(this.answerId, formData)
        : this.quizService.submitAnswer(this.quiz.id, formData);

    request
      .then((res) => {
        this.snackBar.open(`Respostas ${this.isEditMode ? 'atualizadas' : 'salvas'} com sucesso!`, null, {
          duration: 3000,
        });
        this.loaderService.closeLoader();
        this.router.navigate(['/devocional/view', this.quiz.id]);
      })
      .catch((err) => {
        this.snackBar.open(err.error?.message || 'Ocorreu um erro ao enviar suas respostas.', null, { duration: 3000 });
        this.loaderService.closeLoader();
      });
  }
}
